import { User } from '../store/member/memberTypings'
import { ProfileShort } from '../store/commonTypes'

export const addLocationToString = (metaString: string, user: User | ProfileShort) => {
    const location = `${user.region ? user.region + ', ' : ''}${user.country || 'France'}`
    const shortLocation = user.country || 'France'
    const fullMetaString = metaString.replace('{LOCATION}', location)
    if (fullMetaString.length <= 160) return fullMetaString
    return metaString.replace('{LOCATION}', shortLocation)
}
